import { MetaFunction } from "@remix-run/react";
import { getSocialMetaTags } from "app/utils/meta";
import { toKebabCase } from "app/utils/fn";
import { LoaderData } from "./product.loader";

export const productMeta: MetaFunction<LoaderData> = ({ data, params }: any) => {
  if (!data || !data.product) {
    return getSocialMetaTags({
      title: "Product | PromotionalProductsNow",
      description: "Welcome to PromotionalProductsNow",
      url: `https://www.promotionalproductsnow.au/category/${toKebabCase(
        params?.category,
      )}/${toKebabCase(params?.subcategory)}/${params?.slug}`,
      extra: [
        {
          tagName: "link",
          rel: "canonical",
          href: `https://www.promotionalproductsnow.au/category/${toKebabCase(
            params?.category,
          )}/${toKebabCase(params?.subcategory)}/${params?.slug}`,
        },
      ],
    });
  }
  const loaderData = data as LoaderData;
  return getSocialMetaTags({
    title: `${loaderData?.product?.overview?.name || "Product"} | PromotionalProductsNow`,
    description: loaderData.product.product?.description?.slice(0, 160) || "Product details",
    image: loaderData.product.overview?.heroImage || undefined,
    url: loaderData.url || undefined,
    extra: [{ tagName: "link", rel: "canonical", href: loaderData.url || "" }],
  });
};
